import moment from "moment";

import settings from "../settings";

const THAI_LANGUAGE_CODE = 'th';
const THAI_YEAR_OFFSET = 543;

const shiftThaiYear = momentObj => {
  return settings.realm.languageCode === THAI_LANGUAGE_CODE ? moment(momentObj).add(THAI_YEAR_OFFSET, 'year') : momentObj;
};

export const isoToFormattedLocalDateTime = isoString => {
  return isoString ? shiftThaiYear(moment.utc(isoString)).local().format(settings.formats.datetime) : '—';
};

export const isoToFormattedLocalDate = isoString => {
  return shiftThaiYear(moment.utc(isoString)).local().format(settings.formats.date);
};

export const isoToFormattedLocalTime = isoString => {
  return moment.utc(isoString).local().format(settings.formats.time);
};

export const unixToFormattedLocalDateTime = timestamp => {
  return shiftThaiYear(moment.unix(timestamp)).local().format(settings.formats.datetime);
};

export const unixToFormattedLocalDate = timestamp => {
  return shiftThaiYear(moment.unix(timestamp)).local().format(settings.formats.date);
};

export const unixToFormattedLocalTime = timestamp => {
  return moment.unix(timestamp).local().format(settings.formats.time);
};

export const getShiftedIsoString = seconds => {
  return seconds ? moment().add(seconds, 'seconds').toISOString() : null;
};